module.exports = __webpack_public_path__ + "img/spinning-mew.5a3eeaf5.gif";